<div class="container mt-5 mb-3">
    <div class="row">
        <div class="col-md-4">
            <div class="card p-3 mb-2" style="border-color: white;border-style: solid;background-color: #f89a3d;">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="icon"> <i class="bi bi-star-fill" style="color: #f89a3d;"></i> </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0" >Becas Municipales</h6>
                        </div>
                    </div>
                 
                </div>
                <div class="mt-5">
                    <h3 class="heading" style="color: white;">Educacion <br>Especial</h3>
                    <div class="mt-5">
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" style="width: 100%;background-color:white" aria-valuenow="50"
                                aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="mt-3" style="cursor: pointer;" align="right"> <span class="text1" style="color: #9E2342;">Descarga  <span class="text2" style="color: rgb(202, 235, 233);">la convocatoria</span></span> </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="card p-3 mb-2" style="border-color:white;border-style: solid;background-color: #3498db;">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="icon"> <i class="bi bi-shield-fill-check" style="color:#3498db;"></i> </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Becas Municipales</h6>
                        </div>
                    </div>
        
                </div>
                <div class="mt-5">
                    <h3 class="heading" style="color: white;">Excelencia <br><span style="color: #3498db;">.</span></h3>
                    <div class="mt-5">
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" style="width: 100%;background-color:white"
                                aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="mt-3" style="cursor: pointer;" align="right"> <span class="text1"
                                style="color: #9E2342;">Descarga <span class="text2" style="color: rgb(202, 235, 233);">la
                                    convocatoria</span></span> </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="card p-3 mb-2" style="border-color: white;border-style: solid;background-color: #27ae60;">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="icon"> <i class="bi bi-stars" style="color:#27ae60;"></i> </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Becas Municipales</h6>
                        </div>
                    </div>
        
                </div>
                <div class="mt-5">
                    <h3 class="heading" style="color: white;">NLD<br><span style="color: #27ae60;">.</span></h3>
                    <div class="mt-5">
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" style="width: 100%;background-color:white"
                                aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="mt-3" style="cursor: pointer;" align="right"> <span class="text1"
                                style="color: #9E2342;">Descarga <span class="text2" style="color: rgb(202, 235, 233);">la
                                    convocatoria</span></span> </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-4">
            <div class="card p-3 mb-2" style="border-color: white;border-style: solid;background-color: #8e44ad;">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="icon"> <i class="bi bi-award" style="color:#8e44ad;"></i> </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0"  style="color: #e7144a;">Becas Municipales</h6>
                        </div>
                    </div>
        
                </div>
                <div class="mt-5">
                    <h3 class="heading" style="color: white;">Beca  <br>Deportiva</h3>
                    <div class="mt-5">
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" style="width: 100%;background-color:white"
                                aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="mt-3" style="cursor: pointer;" align="right"> <span class="text1"
                                style="color: #e7144a;">Descarga <span class="text2" style="color: rgb(202, 235, 233);">la
                                    convocatoria</span></span> </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="card p-3 mb-2" style="border-color: white;border-style: solid;background-color: #fbc531;">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="icon"> <i class="bi bi-trophy-fill" style="color:#fbc531;"></i> </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Becas Municipales</h6>
                        </div>
                    </div>
        
                </div>
                <div class="mt-5">
                <h3 class="heading" style="color: white;">Beca <br>Cultural</h3>
                    <div class="mt-5">
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" style="width: 100%;background-color:white"
                                aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="mt-3" style="cursor: pointer;" align="right"> <span class="text1"
                                style="color: #9E2342;">Descarga <span class="text2" style="color: rgb(202, 235, 233);">la
                                    convocatoria</span></span> </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2"></div>
     
    </div>
</div>